/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-27 17:53:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-24 14:04:33
 * @FilePath: /goldenSalesMobile/src/api/order.js
 * @Description: 统计报表相关api
 */
import { requestOfPut, requestOfGet,requestOfPost } from "../utils/http"
const baseUrl = 'wechath5/zh-cn/v1/report'

// 获取业绩汇总
export function getTotalPerformance(param) {
  return requestOfGet(baseUrl+'/mobile/dashboard', param)
}
export function getSinglePerformance(param) {
  return requestOfGet(baseUrl+'/mobile/bonus', param)
}
export function getSalesPromotionInfo(param) {
  return requestOfGet(baseUrl+'/mobile/bill/product', param)
}
export function getSalesGoodsInfo(param) {
  return requestOfGet(baseUrl+'/mobile/bill/goods', param)
}
export function getSalesCardInfo(param) {
  return requestOfGet(baseUrl+'/mobile/bill/card', param)
}
export function getJishiPromotionList(param) {
  return requestOfGet(baseUrl+'/mobile/bonus/total', param)
}
export function getMemberStatisticsData(param) {
  return requestOfGet(baseUrl+'/mobile/member/total/consume', param)
}
export function getBaseFinancialData(param) {
  return requestOfGet(baseUrl+'/mobile/business', param)
}
export function getBaseFinancialRealData(param) {
  return requestOfGet(baseUrl+'/mobile/realtime', param)
}



